import { render, staticRenderFns } from "./buttonRecompensa.vue?vue&type=template&id=fab68704&"
import script from "./buttonRecompensa.vue?vue&type=script&lang=js&"
export * from "./buttonRecompensa.vue?vue&type=script&lang=js&"
import style0 from "./buttonRecompensa.vue?vue&type=style&index=0&id=fab68704&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports